import { colorsForMatterType } from '@/utils/colorForMatterType';
import { Form } from './types';

export const colorsForForm = (
  form: Form,
): { foreground: string; background: string } => {
  const values = form.getValues();
  switch (values.feeType) {
    case 'Insurance': {
      switch (values.insuranceProvider) {
        case 'arag':
          return colorsForMatterType(`ARAG`);
        case 'metlife':
          return colorsForMatterType(`MetLife`);
        case 'legalease':
          return colorsForMatterType(`LegalEase`);
        default:
          return colorsForMatterType(`OtherInsurance`);
      }
    }
    case 'Unknown':
      return colorsForMatterType("Don't Know");
    default:
      return colorsForMatterType(values.feeType);
  }
};
